import React from 'react';

import { CheckmarkList } from '@eika/checkmark-list';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import piwik from '@/piwik/piwik';

import useText from '@hooks/use-text';

import { GetGoing } from './get-going';
import { getInfoBannerCheckmarks } from './instruction-steps';

import './GoogleWalletInfoBanner.scss';

export const GoogleWalletInfoBanner = () => {
    const text = useText();

    return (
        <section
            data-track-id={piwik.googlePay.googleWalletInfoBanner.dataTrackId}
            data-track-linkname={piwik.googlePay.googleWalletInfoBanner.dataTrackLinkname}
            className="google-wallet-info-banner"
        >
            <div className="digital-card-watch">
                <RichIcon type={RichIconTypes.DIGITALTKORT_KLOKKE} ariaLabel="Digitalt kort klokke" />
            </div>
            <div className="bullet-points-with-button">
                <GetGoing />
                <div className="google-wallet-check-mark-list">
                    <CheckmarkList checkmarks={getInfoBannerCheckmarks(text)} />
                </div>
            </div>
        </section>
    );
};
